/**
 * 
 * カート
 * 
 */

window.addEventListener('DOMContentLoaded', () => {
  // 数量プラスの処理
  document.querySelectorAll('.js-cart-count-plus').forEach((selector) => {
    selector.addEventListener('click', (e) => {
      e.preventDefault();

      const js_cart_count_label = selector.previousElementSibling;
      const MAX_COUNT = Number(js_cart_count_label.dataset.max) || 100;
      const count = Math.min(Number(js_cart_count_label.innerHTML) + 1, MAX_COUNT);

      js_cart_count_label.innerHTML = count;

      const variantId = selector.closest('[data-variant-id]').dataset.variantId;
      $.post(window.Shopify.routes.root + 'cart/update.js', {
          updates: {
            [variantId]: count
          }
        }, function (data) {
          let js_cart_total_price = document.getElementById('js_cart_total_price');
          js_cart_total_price.innerHTML = (data.total_price / 100).toLocaleString();
        }, "json"
      );
    });
  });

  // 数量マイナスの処理
  document.querySelectorAll('.js-cart-count-minus').forEach((selector) => {
    selector.addEventListener('click', (e) => {
      e.preventDefault();

      const js_cart_count_label = selector.nextElementSibling;
      let count = Number(js_cart_count_label.innerHTML);
      if (count > 1) {
        count--;
        js_cart_count_label.innerHTML = count;

        const variantId = selector.closest('[data-variant-id]').dataset.variantId;
        $.post(window.Shopify.routes.root + 'cart/update.js', {
            updates: {
              [variantId]: count
            }
          }, function (data) {
            // 合計金額の更新
            const js_cart_total_price = document.getElementById('js_cart_total_price');
            js_cart_total_price.innerHTML = (data.total_price / 100).toLocaleString();
          }, "json"
        );

      }
    });
  });

  // バツボタンを押した際に商品をカートから削除する
  document.querySelectorAll('.item-delete-btn').forEach((selector) => {
    selector.addEventListener('click', (e) => {
      e.preventDefault();

      const delete_target = selector.closest('[data-variant-id]');
      const variantId = delete_target.dataset.variantId;

      $.post(window.Shopify.routes.root + 'cart/update.js', {
          updates: {
            // 数量を０にする
            [variantId]: 0
          }
        }, function (data) {
          // 商品を削除する
          delete_target.remove();
          // 合計金額の更新
          const js_cart_total_price = document.getElementById('js_cart_total_price');
          js_cart_total_price.innerHTML = (data.total_price / 100).toLocaleString();

          if (data.item_count < 1) {
            document.querySelector("#cart-template").classList.add('cart--empty');
          } else {
            document.querySelector("#cart-template").classList.remove('cart--empty');
          }
        }, "json"
      );

    })
  })
});

window.addEventListener('DOMContentLoaded', () => {
  const loginButton = document.querySelector('.cta_login');

  if (!loginButton) return;

  let isSavingDeliveryAttributes = false;

  loginButton.addEventListener('click', async (event) => {
    event.preventDefault();

    if (isSavingDeliveryAttributes) return;

    const loginUrl = loginButton.href;
    const dateInput = document.querySelector('[name="attributes[配送希望日]"]');
    const timeInput = document.querySelector('[name="attributes[配送希望時間帯]"]');

    if (!dateInput && !timeInput) {
      window.location.href = loginUrl;
      return;
    }

    const attributes = {};

    if (dateInput) {
      attributes['配送希望日'] = dateInput.value;
    }

    if (timeInput) {
      attributes['配送希望時間帯'] = timeInput.value;
    }

    isSavingDeliveryAttributes = true;
    loginButton.setAttribute('aria-disabled', 'true');
    loginButton.classList.add('is-saving');
    loginButton.style.pointerEvents = 'none';

    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ attributes })
      });

      if (!response.ok) {
        throw new Error('Failed to save delivery attributes.');
      }

      window.location.href = loginUrl;
    } catch (error) {
      console.error(error);
      alert('配送希望日時の保存に失敗しました。お手数ですが、再度お試しください。');
      isSavingDeliveryAttributes = false;
      loginButton.classList.remove('is-saving');
      loginButton.style.pointerEvents = '';
      loginButton.removeAttribute('aria-disabled');
    }
  });
});

// 読み込まれた際に以前カートに入れた商品を表示する
window.addEventListener('DOMContentLoaded', (e) => {
  e.preventDefault();

  const array = JSON.parse(localStorage.getItem('cart-history')) || [];

  var source = document.getElementById("cart-history-template").innerHTML;
  var template = Handlebars.compile(source);

  Promise.all(array.map((handle) => {
    return jQuery.getJSON(window.Shopify.routes.root + `products/${handle}.js`)
  })).then((results) => {
    var context = results.map((product) => { return { title: product.title, image: product.featured_image, url: product.url } });
    document.querySelector('.cart-history-container').innerHTML = template({ context });
  });

  // 以前カートに入れたアイテム
  /**　カートに追加するボタンに共通のclassを指定しておくこと。 */
  document.querySelectorAll('.item-delete-btn').forEach((selector) => {
    // クリックされたら商品のハンドルを保存する
    selector.addEventListener('click', (e) => {
      e.preventDefault();

      const itemHandle = selector.closest('[data-item-handle]').dataset.itemHandle;
      const array = JSON.parse(localStorage.getItem('cart-history')) || [];

      array.unshift(itemHandle);
      if (array.length > 4) array2.pop();
  
      localStorage.setItem('cart-history', JSON.stringify(array));
    });
  })
});

/**
 * 
 * 前払い同意チェックボックスの制御
 * 
 **/
// 前払い同意チェックボックスの制御機能
class PrepaidConsentController {
  constructor() {
    this.checkbox = document.getElementById('cart-attribute-prepaid-consent');
    this.checkoutButton = document.querySelector('button[name="checkout"]');
    this.consentField = document.querySelector('[data-prepaid-consent="true"]');
    this.prepaidConsentHandles = new Set(); // 前払い同意が必要な商品のハンドルを保存
    
    if (this.checkbox && this.checkoutButton) {
      this.init();
    }
  }

  init() {
    // ①初期値はチェックボックスOFF
    this.checkbox.checked = false;
    
    // ②初期状態で購入ボタンを非活性化
    this.updateCheckoutButton();
    
    // 前払い同意が必要な商品のハンドルを収集
    this.collectPrepaidConsentHandles();
    
    // チェックボックスの変更イベント
    this.checkbox.addEventListener('change', () => {
      this.updateCheckoutButton();
    });
    
    // 購入ボタンのクリックイベント
    this.checkoutButton.addEventListener('click', (e) => {
      if (!this.checkbox.checked) {
        e.preventDefault();
        alert('Web上で通知を受けることに承諾してください。');
        return false;
      }
    });
  }

  // 前払い同意が必要な商品のハンドルを収集
  collectPrepaidConsentHandles() {
    // カート内の全商品をチェック
    const cartItems = document.querySelectorAll('[data-item-handle]');
    cartItems.forEach(item => {
      const handle = item.dataset.itemHandle;
      const prepaidConsent = item.dataset.prepaidConsent;
      
      if (handle && prepaidConsent && prepaidConsent !== 'blank' && prepaidConsent !== '') {
        this.prepaidConsentHandles.add(handle);
      }
    });
  }

  updateCheckoutButton() {
    if (this.checkbox.checked) {
      // ④チェックボックスONの状態で購入ボタンが活性化
      this.checkoutButton.disabled = false;
    } else {
      // ②チェックボックスOFFの場合は購入ボタンを非活性
      this.checkoutButton.disabled = true;
    }
  }

  // ⑤該当商品をカートから削除したらチェックボックスが消える
  hideConsentField() {
    if (this.consentField) {
      this.consentField.style.display = 'none';
    }
    // チェックボックスを非表示にする際に、チェック状態をリセットして購入ボタンを活性化
    if (this.checkbox) {
      this.checkbox.checked = false;
    }
    // 前払い同意が必要な商品がない場合は、購入ボタンを強制的に活性化
    if (this.checkoutButton) {
      this.checkoutButton.disabled = false;
    }
  }
}


// 前払い同意が必要かどうかを判定する関数
function checkPrepaidConsentRequired(cartData) {
  if (!prepaidConsentController) return;
  
  // カートが空の場合はチェックボックスを非表示
  if (!cartData.items || cartData.items.length === 0) {
    prepaidConsentController.hideConsentField();
    return;
  }
  
  // 現在のページに前払い同意フィールドが存在するかチェック
  const consentField = document.querySelector('[data-prepaid-consent="true"]');
  if (consentField) {
    // 前払い同意フィールドが存在する場合は表示
    consentField.style.display = 'block';
  } else {
    // 前払い同意フィールドが存在しない場合は非表示
    prepaidConsentController.hideConsentField();
  }
}

// 前払い同意チェックボックスの制御を初期化
let prepaidConsentController = null;

window.addEventListener('DOMContentLoaded', () => {
  prepaidConsentController = new PrepaidConsentController();
});

// $(function() {
//   $('button[name=\"checkout\"]').on('click', function(e) {
//     $(this).closest('form[action=\"\/cart\"]').submit(async function() {
//       var s = sessionStorage.getItem('_kachimo_source') || "unknown",
//           m = sessionStorage.getItem('_kachimo_medium') || "unknown",
//           f = sessionStorage.getItem('_kachimo_fbad') || "unknown";
      
//       var request = {
//         method: 'POST',
//         headers: new Headers({ 'Content-Type': 'application/json' }),
//         body: JSON.stringify({ attributes: { '_param_source': s, '_param_medium': m, '_kachimo_fbad': f } })
//       };

//       await fetch('/cart/update.js', request);
//     })
//   })
// })
